<mat-card appearance="outlined" class="upgrade-card" [class.empty-state]="isEmptyState">
  <mat-card-header class="card-header">{{ header }} </mat-card-header>

  <mat-card-content>
    @if (columns && columns.length > 0) {
      <div class="columns-layout">
        @for (column of columns; track column.icon) {
          <div class="column-item">
            <mat-icon class="column-icon material-icons-outlined" [class.empty-state]="isEmptyState">{{ column.icon }}</mat-icon>
            <h3 class="column-title">{{ column.title }}</h3>
            <p class="column-description">{{ column.description }}</p>
          </div>
        }
      </div>
    } @else if (bodyText) {
      <p class="body-text">{{ bodyText }}</p>
    }
  </mat-card-content>

  <mat-card-footer class="footer-section">
    @if (!isEmptyState) {
      @if (canUpgrade) {
        <la-upgrade-button [text]="buttonText" (action)="action.emit()" [buttonLink]="buttonLink"></la-upgrade-button>
      } @else {
        <span class="label" [class.empty-state]="isEmptyState">Ask your admin to upgrade your subscription</span>
      }
    } @else {
      <ng-content></ng-content>
    }
  </mat-card-footer>
</mat-card>
